<template>
  <div>
    <div v-if="showDetails" class="caption">
        {{ $t('scenario.scenarioWithId', { scenarioId: scenario.id }) + (scenario.absoluteLevel ? ' / ' + $t('scenario.level', { level: scenario.absoluteLevel }) : '') }}
    </div>
    <div>
      <elements
        :scenario="scenario"
        :element-clickable="elementClickable"
        @elementSelected="$emit('elementSelected', $event)"
      />
    </div>
  </div>
</template>
<script>
import Elements from '@/components/global/Elements'

export default {
  name: 'Scenario',

  components: {
    Elements,
  },

  mixins: [],

  data () {
    return {}
  },

  props: {
    scenario: {
      type: Object,
      required: true
    },
    elementClickable: {
      type: Boolean,
      required: false,
      default: false
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: true
    }
  },

}
</script>
<style>

</style>
